import type { ApolloCache, Reference, StoreObject } from '@apollo/client';

export const removePendingInviteFromCache = (
  cache: ApolloCache,
  currentUserId: string | null | undefined,
  groupId: string | null | undefined,
) => {
  if (!groupId) {
    return;
  }

  if (!currentUserId) {
    return;
  }

  const id = cache.identify({ __typename: 'User', _id: currentUserId });

  if (!id) {
    return;
  }

  cache.modify({
    id,
    fields: {
      pendingMemberOfGroupsConnection(existing, { readField }) {
        if (!existing) {
          return existing;
        }

        const edges =
          existing.edges?.filter(
            (edge: StoreObject | Reference) =>
              readField('_id', readField('node', edge)) !== groupId,
          ) ?? [];

        // Derive the decrement from what was actually dropped. Assuming one
        // would let `totalCount` drift down on a repeat call for a group that
        // has already gone from the cache.
        const removed = (existing.edges?.length ?? 0) - edges.length;

        if (!removed) {
          return existing;
        }

        // Only the news banner selects totalCount. Defaulting a missing one to
        // zero would write that back, and the banner's next cache-first read
        // would find it and hide invites that are still outstanding.
        if (typeof existing.totalCount !== 'number') {
          return { ...existing, edges };
        }

        return {
          ...existing,
          edges,
          totalCount: Math.max(0, existing.totalCount - removed),
        };
      },
    },
  });
};
